import React from "react";
import Util from "../../Util";
import Nav from "../../Components/Nav";
import style from "./Style.module.css";
import { Container } from "react-grid-system";
import Footer from "../../Components/Footer";
import { withAlert } from "react-alert";
import { withRouter } from "react-router-dom";
import { Table, Button, Typography, Modal } from "antd";
import Information from "../../asset/infomation.svg";
import AnnounceModal from "./AnnounceModal.js";
import SheetOrdersModal from "./SheetOrdersModal";
import moment from "moment-timezone";
const { Text, Link } = Typography;
//
const PAYMENT_STATUS = {
  PENDING: "PENDING", // New, or re-requested for this month's trf
  SUCCESS: "SUCCESS",
  CARRIED_OVER: "CARRIED_OVER", // overall accumulated still less than 100
  PAUSED: "PAUSED", // Supplemented by reasons eg. Transaction failed, <100THB
  VOID: "VOID", // Will not be paid due to stuffs like copyright
};

class SellRev extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      announceModalVisible: true,
      sheetOrdersModalVisible: false,
      rowSheetOrderModal: undefined,
      data: {
        user: {
          infoEnter: true,
        },
        report: [],
        sellerData: {},
        sheets: [],
      },
      renderMoney: [],
      mapperName: {},
      mapperPrice: {},
      tableDate: [],
      modalRow: {},
    };
  }

  COLUMNS = [
    {
      title: "เดือน",
      dataIndex: "monthString",
      key: "monthString",
    },
    {
      title: "มหาวิทยาลัยที่ลงชีทขาย",
      dataIndex: "storeName",
      key: "storeName",
    },
    {
      title: "ยอดขาย",
      dataIndex: "rawSaleAmount",
      key: "rawSaleAmount",
      render: (text, row) => {
        return <Link onClick={() => this.showModal(row)}>{text}</Link>;
      },
    },
    {
      title: (
        <>
          ส่วนแบ่งรายได้ 60%
          <br />
          (ยอดก่อนหักภาษี ณ ที่จ่าย และค่าธรรมเนียมการโอน)
        </>
      ),
      dataIndex: "sharedAmount",
      key: "sharedAmount",
      align: "center",
    },
    // {
    //   title: "ภาษีหัก ณ ที่จ่าย",
    //   dataIndex: "witholding",
    //   key: "witholding",
    // },
    // {
    //   title: "ยอดจ่ายออกสุทธิ",
    //   dataIndex: "totalPay",
    //   key: "totalPay",
    //   render: (text, _) => {
    //     return (
    //       <Text strong underline>
    //         {text}
    //       </Text>
    //     );
    //   },
    // },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (text, row) => {
        const current = moment().format("YYYY-MM");

        if (current === row.monthString) {
          return (
            <Text strong style={{ color: "#808080" }}>
              รอสรุปยอด
            </Text>
          );
        } else if (text === PAYMENT_STATUS.SUCCESS) {
          return (
            <Text strong type="success">
              โอนแล้ว
            </Text>
          );
        } else if (text === PAYMENT_STATUS.PENDING) {
          return (
            <Text strong type="warning">
              รอโอนเงิน
            </Text>
          );
        } else if (text === PAYMENT_STATUS.PAUSED) {
          return (
            <Text strong type="danger">
              ไม่สำเร็จ
            </Text>
          );
        } else if (text === PAYMENT_STATUS.CARRIED_OVER) {
          return (
            <Text strong type="warning">
              ทบยอด
            </Text>
          );
        } else {
          return (
            <Text strong type="danger">
              รายได้ถูกยกเลิก
            </Text>
          );
        }
      },
    },
    {
      title: "รายการชีท",
      dataIndex: "SheetOrders",
      key: "SheetOrders",
      render: (_, row) => {
        return (
          <Text
            underline
            style={{ cursor: "pointer", whiteSpace: "nowrap" }}
            onClick={() => {
              this.setState({
                sheetOrdersModalVisible: true,
                rowSheetOrderModal: row,
              });
            }}
          >
            ดูรายการ
          </Text>
        );
      },
    },
    {
      title: "หมายเหตุ",
      dataIndex: "remark",
      render: (text, row) => {
        const current = moment().format("YYYY-MM");

        if (current === row.monthString) {
          return (
            <Text>
              ระบบอยู่ระหว่างรวมยอดขายรายเดือน หากมีส่วนแบ่งรายได้ตั้งแต่ 100
              บาทขึ้นไป จะทำการโอนให้วันที่ 20 ของเดือนถัดไป
            </Text>
          );
        } else {
          return (
            <Text>
              {text}
              {row.status === PAYMENT_STATUS.PAUSED ? (
                <p className={style.remarkInfo}>
                  (กรุณาตรวจสอบ ชื่อ นามสกุล และอีเมล)
                </p>
              ) : null}
            </Text>
          );
        }
      },
      // key: "remark",
    },
  ];

  async componentDidMount() {
    const data = await Util.sendPost("/api/seller/getSellRev", {});
    const currentRev = await Util.sendPost(
      "/api/seller/getSellRevCurrentMonth",
      {},
    );

    if (data.success) {
      this.setState({ data: data.data });

      const sheets = data.data.sheets;
      const sheetMap = new Map(
        sheets.map((sh) => [sh._id, { name: sh.name, price: sh.price }]),
      );

      const reports = (currentRev.data.report ?? []).concat(data.data.report);
      const stores = data.data.relaventStores.concat(
        currentRev.data.relaventStores ?? [],
      );

      const storesNameMap = new Map(
        stores.map((s) => [s.code, `${s.name[0]}`]),
      );

      const tableData = reports.map((row) => {
        const isHytextsPay =
          row.year === 2025 &&
          row.month > 8 &&
          row.paymentStatus === PAYMENT_STATUS.SUCCESS;
        const monthString = `${row.year}-${String(row.month).padStart(2, "0")}`;
        const storeName = storesNameMap.get(row.store);

        const rawSaleAmount = row.total;
        const sharedAmount = row.total * 0.6;
        let witholding = isHytextsPay
          ? sharedAmount * 0.01
          : sharedAmount > 1000
            ? sharedAmount * 0.03
            : 0;

        const isNewCalWitholding =
          row.year > 2025 || (row.year === 2025 && row.month === 12);
        if (isNewCalWitholding) {
          witholding = sharedAmount * 0.03;
        }

        const remark = [
          PAYMENT_STATUS.SUCCESS,
          PAYMENT_STATUS.PENDING,
        ].includes(row.paymentStatus)
          ? "อาจถูกเก็บค่าจ่ายข้ามธนาคาร 8 บาท หากไม่ได้ใช้ธนาคารไทยพาณิชย์รับเงิน"
          : row.paymentStatus === PAYMENT_STATUS.CARRIED_OVER
            ? "ยอดขั้นต่ำในการโอนเงิน 100 บาท รายได้จะทบไปในเดือนถัดไปจนกว่าจะถึงยอดที่กำหนด"
            : row.paymentPausedReason + " ";
        const totalPay = sharedAmount - witholding;
        const sheetList = row.sheetList.map((sh) => {
          return {
            _id: sh._id,
            name: sheetMap.get(sh.sheet)?.name,
            count: sh.count,
            totalPrice: sh.totalPrice,
          };
        });

        return {
          monthString,
          storeName,
          status: row.paymentStatus,
          remark: remark,
          paymentDate: row.paymentDate,
          rawSaleAmount: rawSaleAmount.toFixed(2),
          sharedAmount: sharedAmount.toFixed(2),
          witholding: witholding.toFixed(2),
          totalPay: totalPay.toFixed(2),
          orig: row,
          sheetList,
        };
      });
      console.log("tableData", tableData);
      this.setState({ tableData });
    } else this.props.history.push("/seller");
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          title="รายละเอียดยอดขาย"
          open={this.state.isModalVisible}
          onOk={this.handleOk}
          onCancel={this.handleOk}
          footer={[
            <Button key="ok" type="primary" onClick={this.handleOk}>
              OK
            </Button>,
          ]}
        >
          <p>
            {this.state.modalRow?.monthString}: {this.state.modalRow?.storeName}
          </p>
          <Table
            dataSource={this.state.modalRow?.sheetList}
            columns={[
              {
                title: "ชื่อชีท",
                dataIndex: "name",
                key: "name",
              },
              {
                title: "จำนวน",
                dataIndex: "count",
                key: "count",
              },
              {
                title: "ราคารวม",
                dataIndex: "totalPrice",
                key: "totalPrice",
              },
            ]}
          ></Table>
          <p>รวม {this.state.modalRow?.rawSaleAmount} บาท</p>
        </Modal>
        <div className={style.shopPage}>
          <Nav current="seller" user={this.state.data.user} />
          <Container>
            <div className={style.blanker} />
            <div className={style.announce}>
              <p className={style.flexRow}>
                <img src={Information} alt="" /> ระบบจะโอนยอดเงินในวันที่ 20
                ของทุกเดือน หากตรงกับวันหยุด (เสาร์-อาทิตย์
                หรือวันหยุดนักขัตฤกษ์) จะโอนในวันทำการถัดไปโดยอัตโนมัติ
              </p>{" "}
              <p>
                หากต้องการแก้ไขข้อมูลผู้ขายชีทเช่น อีเมล ชื่อธนาคาร เลขบัญชี
                กรุณาติดต่อผ่านอีเมล contact@moresheet.co
              </p>
            </div>
            <div className={style.bigHeader}>รายได้</div>
            <div className={style.sellID}>
              {"รหัสผู้ขาย : " + this.state.data.user._id}
            </div>
            <hr />
            <div className={style.sellDataHead}>นามปากกา</div>
            <div className={style.sellData}>
              {this.state.data.sellerData.codeName}
            </div>
            <div className={style.sellDataHead}>ข้อมูลรับเงิน</div>
            <div className={style.sellDataend}>
              {this.state.data.sellerData.bankInfo}
            </div>
            <hr />
            <div className={style.payContainer}>{this.renderPay()}</div>
          </Container>
        </div>
        <Footer />

        {/* <AnnounceModal
          open={this.state.announceModalVisible}
          onCancel={() => this.setState({ announceModalVisible: false })}
        /> */}
        {/* <AnnounceTransferModal
          open={this.state.announceModalVisible}
          onCancel={() => this.setState({ announceModalVisible: false })}
        /> */}
        <SheetOrdersModal
          open={this.state.sheetOrdersModalVisible}
          onCancel={() => this.setState({ sheetOrdersModalVisible: false })}
          row={this.state.rowSheetOrderModal}
        />
      </React.Fragment>
    );
  }

  showModal = (row) => {
    this.setState({ isModalVisible: true, modalRow: row });
  };

  handleOk = () => {
    this.setState({ isModalVisible: false });
  };

  renderPay = () => {
    return <Table dataSource={this.state.tableData} columns={this.COLUMNS} />;
  };
}

export default withRouter(withAlert()(SellRev));
